<script setup lang="ts">
import { useCart } from '@consumer/services/order'

const cart = useCart()
</script>

<template>
  <div class="text-lg font-semibold">
    {{
      cart.count > cart.recentlyAddedGifts.length
        ? 'Recently added'
        : cart.count
          ? 'Your Cart'
          : 'Your cart is empty'
    }}
  </div>
</template>
